import Vue from 'vue'
import Router from 'vue-router'
import BuyHouseForm from './views/buy_house/buy_house_form'
import Retire from './views/retire/retire'
import RetireResult from './views/retire/retire_result'
import Index from './views/index'
import Scenario from './views/scenario'
import BuyHouseResult from "./views/buy_house/buy_house_result";
import EducationFundForm from "./views/education_fund/education_fund_form"
import EducationFundResult from "./views/education_fund/education_fund_result"

Vue.use(Router)

// 解决重複點擊路由報錯的BUG
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/needs_analysis',
            name: 'needs_analysis',
            component: Index,
            meta:{
                title:'人生藍圖計算機'
            }
        },
        {
            path: '/needs_analysis/retire',
            name: 'retire',
            component: Retire,
            meta:{
                title:'人生藍圖計算機－退休試算'
            }
        },
        {
            path: `/needs_analysis/retire/result/:token`,
            name: 'retire_result',
            component: RetireResult,
            meta:{
                title:'人生藍圖計算機－退休試算結果'
            }
        },
        {
            path: '/needs_analysis/real_estate',
            name: 'buyHouse',
            component: Scenario,
            meta:{
                title:'人生藍圖計算機－買房試算'
            }
        },
        {
            path: '/needs_analysis/real_estate',
            name: 'buyHouse_form',
            component: BuyHouseForm,
            meta:{
                title:'人生藍圖計算機－買房試算'
            }
        },
        {
            path: '/needs_analysis/real_estate/result/:token',
            name: 'buyHouse_result',
            component: BuyHouseResult,
            meta:{
                title:'人生藍圖計算機－買房試算結果'
            }
        },
        {
            path: '/needs_analysis/education_fund',
            name: 'educationFund',
            component: Scenario,
            meta:{
                title:'人生藍圖計算機－子女教育金試算'
            }
        },
        {
            path: '/needs_analysis/education_fund',
            name: 'educationFund_form',
            component: EducationFundForm,
            meta:{
                title:'人生藍圖計算機－子女教育金試算'
            }
        },
        {
            path: '/needs_analysis/education_fund/result/:token',
            name: 'educationFund_result',
            component: EducationFundResult,
            meta:{
                title:'人生藍圖計算機－子女教育金試算結果'
            }
        },
        {path: '*', redirect: {name: 'needs_analysis'}}
    ],
})


export default router;